let mixin={
    data(){
        return{
          token:''
        }
    },
    //通用方法
    methods:{
      getToken(){
        return this.token;
      },
      /**
       * 获取当前列表页面按钮权限
       * @param t_y 当前菜单id（1申请风控2资金锁定3贷款发放4贷后跟踪 5资金池6 全部订单  ）
       */
      getMenuLimit(t_y){
        return this.axios.post('/api/zma/loanMenu/getMenuInfo',{ t_y }).then(res=>{
          if(res.status){
            if(res.data.optTypeList && res.data.optTypeList.length>0) {
              return Promise.resolve(res.data.optTypeList)
            }else{
              this.toLogin();
            }
          }
        }).catch(res=>{
          this.$message.error(this.$t(`error.${res.errorCode}`));
        })
      },

      toLogin(){
        this.$router.currentRoute.path !== '/' &&
        this.$router.replace({
          path: '/',
          query: { redirect: this.$router.currentRoute.name },
        })
      }, // 跳登录

      /**
       * 获取登录人拥有的二级菜单权限
       */
      getMenu(){
        return this.axios.post('/api/zma/loanMenu/getMenu',{ }).then(res=>{
          if(res.status){
            return Promise.resolve(res.data.menuTypeList)
          }
        }).catch(res=>{
          this.$message.error(this.$t(`error.${res.errorCode}`));
        })
      },

      /**
       * 获取当前详情页面按钮权限
       * @param f_l 流水号
       */
      getBtnLimit(f_l){
        return this.axios.post('/api/zma/loanMenu/checkMenu',{ f_l }).then(res=>{
          if(res.status){
            return Promise.resolve(res.data)
          }
        }).catch(res=>{
          this.$message.error(this.$t(`error.${res.errorCode}`));
        })
      },

      isSuper(){
        if(this.$utils.getStorage('userProfile')){
          return parseInt(this.$utils.getStorage('userProfile').isSuper)
        }else{
          return false
        }

      }, // 判断是否是超级管理员

      getFileType(name){
        let arr = name.split('.');
        return arr[arr.length-1].toLowerCase();
      }, // 获取文件类型

      zmaDownloadFile(f_c){
        // let token = this.$utils.getStorage('userProfile').token;
        return '//zb-api.zma-smart.com/api/zma/downFile?f_c=' + f_c+'&token='+this.token;
        // return this.axios.post('/api/zma/downFile',{ f_c }).then(res=>{
        //   if(res.status){
        //     return Promise.resolve(res.data)
        //   }
        // }).catch(res=>{
        //   this.$message.error(this.$t(`error.${res.errorCode}`));
        // })
      }, // 文件下载


      getsSysDict() {
        return this.axios.get("/static/sysDict/sysDictValue.json")
          .then(res => {
            return Promise.resolve(res)
          });
      },// 获取字典表的信息
    },
    //过滤

    created() {
    },
    mounted(){
      this.token = this.$utils.getStorage('userProfile') ? this.$utils.getStorage('userProfile').token :'';
    },

};
export default mixin
